import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import styles from './HomeScreen.module.css';
import runeImage from '../assets/home_logo.png';
import logoImage from '../assets/logo.png';
import LangSwitcher from '../components/LangSwitcher/LangSwitcher';
import { useMemberExpanded } from '../context/MemberExpandedContext';

function HomeScreen() {
  const { t } = useTranslation();
  const { isExpanded } = useMemberExpanded();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const handleNavClick = (e) => {
    if (isExpanded) e.preventDefault();
  };

  return (
    <section className={styles.hero}>
      <div className={styles.smoke1} />
      <div className={styles.smoke2} />
      <div className={styles.smoke3} />
      <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ''}`}>
        <div className={styles.logoLink}>
          <img src={logoImage} alt="Sleep Token" className={styles.logo} />
        </div>
        <ul>
          <li><a href="#inicio"   onClick={handleNavClick}>{t('nav.inicio')}</a></li>
          <li><a href="#members"  onClick={handleNavClick}>{t('nav.members')}</a></li>
          <li><a href="#albuns"   onClick={handleNavClick}>{t('nav.albuns')}</a></li>
          <li><a href="#lore"     onClick={handleNavClick}>{t('nav.lore')}</a></li>
        </ul>
        <LangSwitcher />
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
          onClick={() => { if (!isExpanded) setMenuOpen(o => !o); }}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* Mobile overlay menu */}
      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}>
        <ul>
          <li><a href="#inicio"  onClick={(e) => { handleNavClick(e); if (!isExpanded) closeMenu(); }}>{t('nav.inicio')}</a></li>
          <li><a href="#members" onClick={(e) => { handleNavClick(e); if (!isExpanded) closeMenu(); }}>{t('nav.members')}</a></li>
          <li><a href="#albuns"  onClick={(e) => { handleNavClick(e); if (!isExpanded) closeMenu(); }}>{t('nav.albuns')}</a></li>
          <li><a href="#lore"    onClick={(e) => { handleNavClick(e); if (!isExpanded) closeMenu(); }}>{t('nav.lore')}</a></li>
        </ul>
        <LangSwitcher />
      </div>

      <div className={styles.runeWrapper}>
        <div className={styles.stormGlow} />
        <div className={styles.lightning1} />
        <div className={styles.lightning2} />
        <div className={styles.lightning3} />
        <img src={runeImage} alt="rune" className={styles.rune} />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.title}>
          <p><span className={styles.glitch}>Sleep</span></p>
          <p><span className={styles.glitch} style={{ animationDelay: '0.4s' }}>Token</span></p>
        </div>
        <div className={styles.subtitle}>
          <p>WORSHIP</p>
        </div>
      </div>
    </section>
  );
}

export default HomeScreen;